/** Token de acesso para o fluxo SSE.
 *
 *  O fluxo não passa pelo interceptador de refresh do axios, então a renovação
 *  acontece ANTES de abrir a conexão: se o access está a menos de um minuto de
 *  vencer, ou nem existe em memória depois de um reload, renova pelo refresh.
 *  O `exp` é lido do próprio JWT, sem biblioteca. */
import { refreshAccessToken } from '@/core/api/client'
import { tokenStore } from '@/core/auth/tokenStore'

const MARGEM_MS = 60_000

/** Instante de expiração do JWT em milissegundos, ou null se não der para ler. */
export function expiracaoDoJwt(token: string): number | null {
  const partes = token.split('.')
  if (partes.length < 2) return null
  try {
    const base64 = partes[1].replace(/-/g, '+').replace(/_/g, '/')
    const preenchido = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    const json = decodeURIComponent(
      Array.from(atob(preenchido), (c) => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`).join(''),
    )
    const carga: unknown = JSON.parse(json)
    const exp = carga && typeof carga === 'object' ? (carga as { exp?: unknown }).exp : undefined
    return typeof exp === 'number' ? exp * 1000 : null
  } catch {
    return null
  }
}

export async function tokenParaOFluxo(): Promise<string | null> {
  const atual = tokenStore.getAccess()
  const expira = atual ? expiracaoDoJwt(atual) : null
  const aindaVale = atual !== null && (expira === null || expira - Date.now() > MARGEM_MS)
  if (aindaVale) return atual
  if (!tokenStore.getRefresh()) return atual
  try {
    return await refreshAccessToken()
  } catch {
    return atual
  }
}
